export default class Faq {
    constructor() {
        this.sections = document.querySelectorAll('.block-faq');
        if (this.sections.length > 0) {
            this.init();
        }
    }

    init() {
        this.sections.forEach(section => {
            this.bindAccordion(section);
            this.buildTabs(section);
        });
    }

    // --- ACCORDION
    bindAccordion(section) {
        const allQuestions = section.querySelectorAll('.faq-item');
        allQuestions.forEach(question => {
            const questionTitle = question.querySelector('.title');
            questionTitle.addEventListener('click', () => {
                question.classList.toggle('active');
            });
        });
    }

    // --- TABS DE CATEGORIA
    buildTabs(section) {
        const tabsContainer = section.querySelector('.faq-tabs');
        const select = section.querySelector('.faq-select'); // mobile
        const categories = section.querySelectorAll('.block-faq-category');
        if ((!tabsContainer && !select) || categories.length === 0) return;

        categories.forEach((cat, index) => {
            const title = cat.dataset.title || `Categoria ${index + 1}`;

            // --- Botão desktop ---
            if (tabsContainer) {
                const btn = document.createElement('button');
                btn.className =
                    "faq-tab block whitespace-nowrap font-semibold font-montserrat text-xs/150 tracking-tightest p-4 relative before:absolute before:w-0 before:h-[0.1875rem] before:content-[''] before:left-0 before:bg-primary before:bottom-0 hover:before:w-full transition-all border-none text-darkest [&.active]:before:w-full [&.active]:bg-lightf4 [&.active]:text-primary uppercase";
                btn.innerText = title;
                btn.dataset.index = index;
                btn.addEventListener('click', () => this.activateTab(section, index));
                tabsContainer.appendChild(btn);
            }

            // --- Option mobile ---
            if (select) {
                const option = document.createElement('option');
                option.value = index;
                option.text = title;
                select.appendChild(option);
            }
        });

        // ativa a primeira por padrão
        this.activateTab(section, 0);

        // evento mobile
        if (select) {
            select.addEventListener('change', e => {
                const idx = parseInt(e.target.value);
                this.activateTab(section, idx);
            });
        }
    }


    activateTab(section, index) {
        const tabs = section.querySelectorAll('.faq-tab');
        const categories = section.querySelectorAll('.block-faq-category');

        // reset
        tabs.forEach(tab => tab.classList.remove('active'));
        categories.forEach(cat => cat.classList.add('hidden'));

        // ativa
        const activeTab = tabs[index];
        const activeCat = categories[index];
        if (activeTab && activeCat) {
            activeTab.classList.add('active'); // agora só ativa a classe
            activeCat.classList.remove('hidden');
        }
    }
}

if (document.querySelector('.block-faq')) {
    new Faq();
}
